// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import { RadioStyle } from "@insite/mobius/Radio";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { RadioStyleProps } from "@store/MobiusOverrides/Radio/Radio";
import { RadioGroupStyleProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import { checkboxDescriptionSpacingStyles } from "@store/Themes/common/mixins/checkbox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusOutlineStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Checkbox ------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const radio: Styleguide["radio"] = {
    defaultProps: {
        css: css<any>`
            display: flex;
            ${({ theme }) => theme.design.typography.lineHeight.small}

            input {
                position: absolute;
                clip: rect(0, 0, 0, 0);

                &:focus {
                    clip: unset;
                }

                & + label {
                    margin: 0;
                    cursor: pointer;

                    &::before {
                        height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 20)}px;
                        width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 20)}px;
                        border-width: ${pxToRem(1)};
                        margin-right: 0.7em;
                        flex-shrink: 0;
                    }

                    &:hover::before {
                        border-color: ${getColor("primary")};
                    }

                }

                &:focus + label::before {
                    box-shadow: 0 0 0 ${pxToRem(2)} ${getProp("theme.focus.color")};
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${getColor("primary")};
                    background: ${getColor("common.background")};
                }

                &:checked + label::after {
                    content: "";
                    display: block;
                    height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 12)}px;
                    width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 12)}px;
                    border-radius: 50%;
                    background: ${getColor("primary")};
                    position: absolute;
                    left: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 3 : 4)}px;
                    top: calc(50% - ${({ _sizeVariant }) => (_sizeVariant === "small" ? 3 : 4)}px);
                }

                &:checked:disabled,
                &:disabled {
                    & + label::before {
                        border-color: ${getColor("common.disabled")};
                    }

                    & + label::after {
                        background: ${getColor("common.disabled")};
                    }
                }
            }

            &:hover {
                input {
                    & + label {
                        &::before {
                            border-color: ${getColor("primary")};
                        }
                    }
                }
            }
        `,
    },
    groupDefaultProps: {
        css: css<RadioGroupStyleProps>`
            ${checkboxDescriptionSpacingStyles()}
            ${({ _sizeVariant = "default", horizontal }) => {
                const { descriptionSpacing, itemSpacing } = checkboxSizes[_sizeVariant] as any;

                if (horizontal) {
                    return css`
                        &::before {
                            content: "";
                            display: block;
                            margin-top: -${pxToRem(itemSpacing)};
                        }

                        > ${RadioStyle} {
                            margin-top: ${pxToRem(itemSpacing)};
                            margin-right: 1em;

                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    `;
                }

                return css`
                    ${RadioStyle} + ${RadioStyle} {
                        margin-top: ${pxToRem(itemSpacing)};
                    }
                `;
            }}
        ` as any,
    },
};

export default radio;
